import { Link } from "react-router-dom";
import BrandMark from "./BrandMark";
import { APP_SIGN_IN_URL } from "@/lib/appLinks";

const Footer = () => (
  <footer className="border-t border-guinep-line/60 bg-white py-12">
    <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-8 px-5 sm:px-8 md:flex-row">
      <div className="flex items-center gap-2">
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-guinep-soft">
          <BrandMark size={17} />
        </span>
        <span className="font-serif text-lg font-semibold tracking-tight text-guinep-ink">Guinep Seed</span>
      </div>

      <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
        <Link to="/privacy" data-testid="footer-privacy-link" className="text-sm text-guinep-mute transition-colors hover:text-guinep-ink">
          Privacy
        </Link>
        <Link to="/terms" data-testid="footer-terms-link" className="text-sm text-guinep-mute transition-colors hover:text-guinep-ink">
          Terms
        </Link>
        <a href={APP_SIGN_IN_URL} data-testid="footer-signin-link" className="text-sm text-guinep-mute transition-colors hover:text-guinep-ink">
          Sign in
        </a>
        <Link to="/contact" data-testid="footer-contact-link" className="text-sm text-guinep-mute transition-colors hover:text-guinep-ink">
          Contact
        </Link>
      </nav>

      <p className="text-xs text-guinep-mute/70">© 2026 Guinep Seed. From social discovery to client action.</p>
    </div>
  </footer>
);

export default Footer;
